<template>
  <div class="main">
    <div class="content">
         <p style="font-size: 24px;margin: 30px 0;">该账号为机构游客，请先完善企业信息</p>
         <div class="tip">
            <p>仅支持完善企业信息的管理员登录，未找到该账号担任管理员的组织，你可选择：</p>
            <p>1、直接完善企业信息，成为管理员 </p>
            <p>2、更换账号重新登录 </p>
         </div>
         <div>
          <el-button
            style="width: 120px"
            type="primary"
            size=""
            autofocus
            :disabled="!checked"
            @click="join()"
            >完善机构资料</el-button
          >
          <el-button
            style="margin-left: 20px; width: 120px"
            size=""
            @click="login()"
            >重新登录</el-button
          >
         </div>
    </div>
  </div>
</template>

<script>
import {validateIdcard } from "@/utils/validate.js";
import {
  handleRegister,
} from "@/api/register/index.js";
export default {
  props: {},
  data() {
    return {
      orgName:'',
      checked: true,
      status:'1'
    };
  },
  computed: {},
  watch: {},
  mounted() {},
  created() {
  },
  methods: {
    async join() {
      // this.$emit("changeStep", 2);
         this.$message({
            type: "warning",
            message: "还未开发",
          });      
    },
    login() {
       this.$emit("changeStep", 1);
    },
  },
};
</script>

<style lang="less" scoped>
.main {
    display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  margin-top: 4%;
  .content {
    margin-top: 30px;
    width: 650px;
    text-align: center;
    .tip{
      text-align: left;
      font-size: 14px;
      color: #555555;
      margin: 50px;
      p{
        margin: 10px;
      }
    }
  }
}
</style>
